'use strict';

import BaseService from './base.service';

class ItemsService extends BaseService {
    /* @ngInject */
    constructor(Item, SegaUser) {
        super(Item, SegaUser);
    }

    createFromTpl(opts = {template: null, procedure: null}) {
        let item = new this.Model({
            name: opts.template.name,
            cost: opts.template.cost,
            finalPrice: opts.template.price,
            procedure: opts.procedure
        });
        return item;
    }

}

export default ItemsService;
